<template>
  <div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Operation</span>
      </div>
      <select name="operator" v-model="data.method" class="form-control">
        <option v-for="(method,index) in methods" :value="method.toLowerCase()" :key="index">{{method}}</option>
      </select>
    </div>

    <div class="alert alert-info">
        {{help[data.method]}}
    </div>

    <div class="input-group mb-3" v-if="['absent', 'append', 'append unique', 'remove', 'prepend', 'insert', 'present'].includes(data.method)">
      <div class="input-group-prepend">
        <span class="input-group-text">Element</span>
      </div>
      <input type="text" class="form-control" v-model="data.element" placeholder="Element to be appended/removed">
    </div>

    <div class="input-group mb-3" v-if="['pop', 'insert'].includes(data.method)">
      <div class="input-group-prepend">
        <span class="input-group-text">Position</span>
      </div>
      <input type="number" class="form-control" v-model="data.position" placeholder="Position of the element to insert/remove">
    </div>

    <div class="input-group mb-3" v-if="['absent', 'present'].includes(data.method)">
      <div class="input-group-prepend">
        <span class="input-group-text">Error Message</span>
      </div>
      <input type="text" class="form-control" v-model="data.error" :placeholder="'Error message that will be sent if element not ' + data.method + ' in list'">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">List</span>
      </div>
      <input type="text" class="form-control" v-model="data.list" placeholder="List name">
    </div>



  </div>
</template>


<script type="text/javascript">

  export default {
    name: 'ArrayOperation',
    components: {
    },
    props: {
      data: Object
    },
    data: function() {
      return {
        methods: ["absent", "append", "append unique", "clear", "insert", "length", "pop", "popFirst", "popLast", "prepend", "present", "remove", "sort"],
        help: {
          absent: "Check if element absent in the list, if present error message will be sent to user.",
          append: "Adds an element at the end of the list",
          'append unique': "Adds an element at the end of the list if it is not already present",
          clear: "Removes all the elements from the list",
          insert: "Adds an element at the specified position",
          length: "Returns the number of elements in the list, use variable 'element_count' to get the number of elements in the list",
          pop: "Removes element from the list at the specified position",
          popfirst: "Removes first element from the list",
          poplast: "Removes last element from the list",
          prepend: "Adds an element at the beginning of the list",
          present: "Check if element present in the list, if absent error message will be sent to user.",
          remove: "Removes the first item with the specified element from the list",
          sort: "Sorts the list"
        }
      }
    }
  }
</script>
